import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class ClassRoom extends MongoEntity {
  static override _class = 'ClassRoom';
  static override _collectionName = 'classrooms';

  /** The owning Teacher's `_id` (not the AdornisUser id) — see db/teacher.ts. */
  @Field(() => String)
  teacherID!: string;

  @Field(() => String)
  name!: string;

  /** 6-char join code students type in to request membership; regenerable, see regenerate-classroom-code.ts. */
  @Field(() => String)
  code!: string;

  @Field(() => String)
  createdAt!: string;
}
